import { RouteObject } from "react-router-dom";
import { CreateFilm } from "../features/films/pages/create.page";
import { AllFilms } from "../features/films/pages/all.page";
import { ViewFilm } from "../features/films/pages/view.page";
import { WithAuth } from "../components/layout/with-auth/with-auth.component";
import { DistributeFilm } from "../features/films/pages/distribute.page";

export const filmsRoutes: RouteObject[] = [
  {
    path: "/f",
    element: (
      <WithAuth>
        <AllFilms />
      </WithAuth>
    ),
  },
  {
    path: "/f/create",
    element: (
      <WithAuth>
        <CreateFilm />
      </WithAuth>
    ),
  },
  {
    path: "/f/:customURL",
    element: (
      <WithAuth>
        <ViewFilm />
      </WithAuth>
    ),
  },
  {
    path: "/f/:customURL/edit",
    element: (
      <WithAuth>
        <CreateFilm editing />
      </WithAuth>
    ),
  },
  {
    path: "/f/:customURL/distribute",
    element: (
      <WithAuth>
        <DistributeFilm />
      </WithAuth>
    ),
  },
];
